import { addFocusRingStyles } from "@busbud/design-system-components/dist/utilities";

import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { breakpoints, colors, space, spacing } = theme.busbud;

  return {
    layoutRoot: {
      padding: spacing(2, 0),
      backgroundColor: colors.background.primary.opaque,
      [breakpoints.up("sm")]: {
        padding: spacing(4, 0)
      },
      [breakpoints.up("lg")]: {
        padding: spacing(6, 0)
      },
      "&:focus-visible": {
        position: "relative", // For `::before`
        outline: "none",
        "&::before": {
          content: "''",
          position: "absolute", // Containing block: `&:focus-visible`
          inset: space.component.focusRing, // Positions edge-to-edge of the `root` element considering the width of the ring.
          pointerEvents: "none", // Prevents overlapping above the parent.
          ...addFocusRingStyles(theme, {
            has_default_rounding: true
          })
        }
      }
    },
    navigation: {
      marginBottom: spacing(2.5),

      [breakpoints.up("sm")]: {
        marginBottom: spacing(3)
      },
      [breakpoints.up("md")]: {
        marginBottom: 0,
        minWidth: spacing(27.5),
        maxWidth: spacing(27.5)
      }
    },
    content: {
      flexGrow: 1,

      [breakpoints.up("md")]: {
        marginLeft: spacing(4)
      },
      [breakpoints.up("lg")]: {
        marginLeft: spacing(8.75)
      },
      [breakpoints.up("xl")]: {
        marginLeft: spacing(11)
      }
    }
  };
});
